import React, { FC } from 'react';

import { Container, ContainerProps, Text } from '@lglp/components';
import { FooterContent } from '@lglp/prismic-client';

import CTAArrow from '../../../Icons/CTAArrow';
import { LinkedComponent } from '../../../LinkedComponent';
import styles from './FooterContents.module.scss';

export const FooterContents: FC<FooterContentsProps> = ({
  contents,
  className,
}) => (
  <Container className={className}>
    {contents?.map((content, index) => (
      <LinkedComponent
        key={index}
        link={content.cta.link}
        className={[styles.linkContainer, 'animate-svg']}
      >
        <Text className={styles.title} body={content.title} />
        <Text className={styles.subtitle} body={content.subtitle} />
        <Container className={styles.ctaContainer}>
          <Text className={styles.label} body={content.cta.label} />
          <CTAArrow />
        </Container>
      </LinkedComponent>
    ))}
  </Container>
);

type FooterContentsProps = ContainerProps & {
  contents: FooterContent[];
};
